import * as React from "react";
import {
  Datagrid,
  DateField,
  FunctionField,
  List,
  ListProps,
  TextField,
} from "react-admin";
import Pagination from "../Components/Pagination";

export const SettlementList = (props: ListProps): React.ReactElement => {
  return (
      <List
        {...props}
        bulkActionButtons={false}
        title={"واریزی ها"}
        perPage={50}
        pagination={<Pagination />}
      >
        <Datagrid>

          {/* <TextField label="ID" source="id" /> */}
          <FunctionField
            label="مبلغ"
            render={(record: any) => <p>{record.amount} ریال</p>}
          />
          <DateField locales={"fa-IR"} label="تاریخ واریز" source="settledAt" />
          {/* <DateField source="createdAt" label="تاریخ ایجاد" /> */}
          {/* <TextField label="ایجاد توسط" source="createdBy" /> */}
          <TextField label="شماره حساب مقصد" source="destinationAccountNo" />
          {/* <TextField label="شناسه پزشک" source="doctorId" /> */}
          {/* <TextField label="شماره حساب مبدا" source="sourceAccountNo" /> */}
          {/* <TextField label="وضعیت پرداخت" source="status" /> */}
          {/* <DateField source="updatedAt" label="Updated At" /> */}
          {/* <TextField label="updated by" source="updatedBy" /> */}
        </Datagrid>
      </List>
  );
};
